// extracted by mini-css-extract-plugin
module.exports = {"loadContainer":"PageSpinner_loadContainer__28OnH","loader":"PageSpinner_loader__1u2CR"};